<template>
  <div class="flex items-center gap-3">
    <NButton variant="flat" color="gray" class="flex-1" @click="remove()">
      <NText variant="caption1" weight="bold">
        {{ t('common.refuse') }}
      </NText>
    </NButton>

    <NButton
      v-gid="{
        module: 'order',
        screen: 'home',
        section: 'deleteOrderDialog',
        component: gidComponentGenerator,
      }"
      variant="fill"
      color="red"
      class="flex-1"
      :disabled="loadingDeleteOrder"
      :loading="loadingDeleteOrder"
      @click="handleDeleteOrder"
    >
      <NText variant="caption1" weight="bold">
        {{ t('modules.order.cancelOrder') }}
      </NText>
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { OrderItem, OrderTypeEnum, PortfolioItem } from '@libs/api-reference';
import { useDialog } from '@negar/core';
import { isAlgorithmOrder } from '@core/order';

const emit = defineEmits<{
  (e: 'deleteOrder', value: { selectedOrder: OrderItem & PortfolioItem }): void;
}>();

const props = defineProps<{
  order: OrderItem & PortfolioItem;
  isFromPortfolio?: boolean;
  loadingDeleteOrder: boolean;
}>();

const { t } = useI18n();

const { remove } = useDialog();

const orderType = computed(() => {
  if (props.isFromPortfolio) {
    return t('modules.order.SLTP');
  }

  return OrderTypeEnum[props.order?.orderType] as string;
});

const handleDeleteOrder = () => {
  if (props.isFromPortfolio) {
    return emit('deleteOrder', {
      selectedOrder: {
        ...props.order,
        orderId: String(props.order.falconAlgorithmInfo?.algorithmId ?? ''),
      },
    });
  }

  emit('deleteOrder', { selectedOrder: props.order });

  remove();
};

const gidComponentGenerator = computed(() => {
  if (isAlgorithmOrder(props.order)) {
    return `cancel${orderType.value}OrderButton`;
  } else if (props.isFromPortfolio) {
    return 'cancelSLTPOrderButton';
  } else {
    return 'cancelOrderButton';
  }
});
</script>
